'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.OSOBA = exports.INTDOR = exports.TEL = exports.EMAIL = exports.DS = exports.ADRDOR = exports.ADRDORREG = exports.ADRTRVSDL = exports.ADR = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:56:38Z                      #

// ##############################################################

/**
 * Určuje typ kontaktu.
 */

/**
 * Adresa.
 */
var ADR = exports.ADR = 'ADR';

/**
 * Adresa trvalého pobytu/sídla.
 */
var ADRTRVSDL = exports.ADRTRVSDL = 'ADRTRVSDL';

/**
 * Doručovací adresa z registrů.
 */
var ADRDORREG = exports.ADRDORREG = 'ADRDORREG';

/**
 * Kontaktní doručovací adresa.
 */
var ADRDOR = exports.ADRDOR = 'ADRDOR';

/**
 * Datová schránka.
 */
var DS = exports.DS = 'DS';

/**
 * E-mail.
 */
var EMAIL = exports.EMAIL = 'EMAIL';

/**
 * Telefon.
 */
var TEL = exports.TEL = 'TEL';

/**
 * Interní doričení.
 */
var INTDOR = exports.INTDOR = 'INTDOR';

/**
 * Kontaktní osoba.
 */
var OSOBA = exports.OSOBA = 'OSOBA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ADR, ADRTRVSDL, ADRDORREG, ADRDOR, DS, EMAIL, TEL, INTDOR, OSOBA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ADR, { caption: 'Adresa.' }), (0, _defineProperty3.default)(_params, ADRTRVSDL, { caption: 'Adresa trvalého pobytu/sídla.' }), (0, _defineProperty3.default)(_params, ADRDORREG, { caption: 'Doručovací adresa z registrů.' }), (0, _defineProperty3.default)(_params, ADRDOR, { caption: 'Kontaktní doručovací adresa.' }), (0, _defineProperty3.default)(_params, DS, { caption: 'Datová schránka.' }), (0, _defineProperty3.default)(_params, EMAIL, { caption: 'E-mail.' }), (0, _defineProperty3.default)(_params, TEL, { caption: 'Telefon.' }), (0, _defineProperty3.default)(_params, INTDOR, { caption: 'Interní doričení.' }), (0, _defineProperty3.default)(_params, OSOBA, { caption: 'Kontaktní osoba.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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